import React from 'react';
import { Wallet } from 'lucide-react';
import Wordmark from '@/components/ui/Wordmark';

export default function Logo({ size = 'default', showText = true, variant = 'default' }) {
  const sizes = {
    small: { icon: 'w-6 h-6', text: 'text-lg' },
    default: { icon: 'w-8 h-8', text: 'text-xl' },
    large: { icon: 'w-12 h-12', text: 'text-3xl' }
  };

  const s = sizes[size] || sizes.default;

  return (
    <div className="flex items-center gap-2">
      <div className="relative">
        <div className="absolute inset-0 bg-gradient-to-br from-emerald-400 to-teal-600 rounded-xl blur-sm opacity-50" />
        <div className="relative bg-gradient-to-br from-emerald-500 to-teal-600 rounded-xl p-2">
          <Wallet className={`${s.icon} text-white`} />
        </div>
      </div>
      {showText && (
        <Wordmark size={size} variant={variant} />
      )}
    </div>
  );
}